var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chat-container"},_vm._l((_vm.messages),function(msg,index){return _c('div',{key:index,domProps:{"innerHTML":_vm._s(_vm.mdToHtml(msg))}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }